import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44cf627c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "responded_chargeback",
  class: "bg-body",
  "data-kt-drawer": "true",
  "data-kt-drawer-name": "responded",
  "data-kt-drawer-activate": "true",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-width": "{default:'400px', 'lg': '475px'}",
  "data-kt-drawer-direction": "end",
  "data-kt-drawer-toggle": "#responded_chargeback_toggle",
  "data-kt-drawer-close": "#responded_chargeback_close"
}
const _hoisted_2 = { class: "card shadow-none w-100" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title fs-5 pe-3" }, [
    /*#__PURE__*/_createTextVNode(" Chargeback Details"),
    /*#__PURE__*/_createElementVNode("span", { class: "ms-3 badge badge-light-primary" })
  ])
], -1))
const _hoisted_4 = { class: "p-5" }
const _hoisted_5 = { class: "table align-middle table-row-bordered mb-0 fs-7 gy-3 min-w-300px" }
const _hoisted_6 = { class: "fw-semibold text-gray-600" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-muted" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 me-2" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.3",
          d: "M19 3.40002C18.4 3.40002 18 3.80002 18 4.40002V8.40002H14V4.40002C14 3.80002 13.6 3.40002 13 3.40002C12.4 3.40002 12 3.80002 12 4.40002V8.40002H8V4.40002C8 3.80002 7.6 3.40002 7 3.40002C6.4 3.40002 6 3.80002 6 4.40002V8.40002H2V4.40002C2 3.80002 1.6 3.40002 1 3.40002C0.4 3.40002 0 3.80002 0 4.40002V19.4C0 20 0.4 20.4 1 20.4H19C19.6 20.4 20 20 20 19.4V4.40002C20 3.80002 19.6 3.40002 19 3.40002ZM18 10.4V13.4H14V10.4H18ZM12 10.4V13.4H8V10.4H12ZM12 15.4V18.4H8V15.4H12ZM6 10.4V13.4H2V10.4H6ZM2 15.4H6V18.4H2V15.4ZM14 18.4V15.4H18V18.4H14Z",
          fill: "currentColor"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          d: "M19 0.400024H1C0.4 0.400024 0 0.800024 0 1.40002V4.40002C0 5.00002 0.4 5.40002 1 5.40002H19C19.6 5.40002 20 5.00002 20 4.40002V1.40002C20 0.800024 19.6 0.400024 19 0.400024Z",
          fill: "currentColor"
        })
      ])
    ]),
    /*#__PURE__*/_createTextVNode("Parent ID ")
  ])
], -1))
const _hoisted_8 = { class: "fw-bold text-end" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-muted" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 me-2" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        width: "20",
        height: "21",
        viewBox: "0 0 20 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.3",
          d: "M19 3.40002C18.4 3.40002 18 3.80002 18 4.40002V8.40002H14V4.40002C14 3.80002 13.6 3.40002 13 3.40002C12.4 3.40002 12 3.80002 12 4.40002V8.40002H8V4.40002C8 3.80002 7.6 3.40002 7 3.40002C6.4 3.40002 6 3.80002 6 4.40002V8.40002H2V4.40002C2 3.80002 1.6 3.40002 1 3.40002C0.4 3.40002 0 3.80002 0 4.40002V19.4C0 20 0.4 20.4 1 20.4H19C19.6 20.4 20 20 20 19.4V4.40002C20 3.80002 19.6 3.40002 19 3.40002ZM18 10.4V13.4H14V10.4H18ZM12 10.4V13.4H8V10.4H12ZM12 15.4V18.4H8V15.4H12ZM6 10.4V13.4H2V10.4H6ZM2 15.4H6V18.4H2V15.4ZM14 18.4V15.4H18V18.4H14Z",
          fill: "currentColor"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          d: "M19 0.400024H1C0.4 0.400024 0 0.800024 0 1.40002V4.40002C0 5.00002 0.4 5.40002 1 5.40002H19C19.6 5.40002 20 5.00002 20 4.40002V1.40002C20 0.800024 19.6 0.400024 19 0.400024Z",
          fill: "currentColor"
        })
      ])
    ]),
    /*#__PURE__*/_createTextVNode("Case number ")
  ])
], -1))
const _hoisted_10 = { class: "fw-bold text-end" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-muted" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 me-2" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.3",
          d: "M3.20001 5.91897L16.9 3.01895C17.4 2.91895 18 3.219 18.1 3.819L19.2 9.01895L3.20001 5.91897Z",
          fill: "currentColor"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.3",
          d: "M13 13.9189C13 12.2189 14.3 10.9189 16 10.9189H21C21.6 10.9189 22 11.3189 22 11.9189V15.9189C22 16.5189 21.6 16.9189 21 16.9189H16C14.3 16.9189 13 15.6189 13 13.9189ZM16 12.4189C15.2 12.4189 14.5 13.1189 14.5 13.9189C14.5 14.7189 15.2 15.4189 16 15.4189C16.8 15.4189 17.5 14.7189 17.5 13.9189C17.5 13.1189 16.8 12.4189 16 12.4189Z",
          fill: "currentColor"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          d: "M13 13.9189C13 12.2189 14.3 10.9189 16 10.9189H21V7.91895C21 6.81895 20.1 5.91895 19 5.91895H3C2.4 5.91895 2 6.31895 2 6.91895V20.9189C2 21.5189 2.4 21.9189 3 21.9189H19C20.1 21.9189 21 21.0189 21 19.9189V16.9189H16C14.3 16.9189 13 15.6189 13 13.9189Z",
          fill: "currentColor"
        })
      ])
    ]),
    /*#__PURE__*/_createTextVNode("Dispute Date ")
  ])
], -1))
const _hoisted_12 = { class: "fw-bold text-end" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-muted" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 me-2" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          d: "M20 8H16C15.4 8 15 8.4 15 9V16H10V17C10 17.6 10.4 18 11 18H16C16 16.9 16.9 16 18 16C19.1 16 20 16.9 20 18H21C21.6 18 22 17.6 22 17V13L20 8Z",
          fill: "currentColor"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.3",
          d: "M20 18C20 19.1 19.1 20 18 20C16.9 20 16 19.1 16 18C16 16.9 16.9 16 18 16C19.1 16 20 16.9 20 18ZM15 4C15 3.4 14.6 3 14 3H3C2.4 3 2 3.4 2 4V13C2 13.6 2.4 14 3 14H15V4ZM6 16C4.9 16 4 16.9 4 18C4 19.1 4.9 20 6 20C7.1 20 8 19.1 8 18C8 16.9 7.1 16 6 16Z",
          fill: "currentColor"
        })
      ])
    ]),
    /*#__PURE__*/_createTextVNode("Dispute Amount ")
  ])
], -1))
const _hoisted_14 = { class: "fw-bold text-end" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-muted" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 me-2" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          d: "M20 8H16C15.4 8 15 8.4 15 9V16H10V17C10 17.6 10.4 18 11 18H16C16 16.9 16.9 16 18 16C19.1 16 20 16.9 20 18H21C21.6 18 22 17.6 22 17V13L20 8Z",
          fill: "currentColor"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.3",
          d: "M20 18C20 19.1 19.1 20 18 20C16.9 20 16 19.1 16 18C16 16.9 16.9 16 18 16C19.1 16 20 16.9 20 18ZM15 4C15 3.4 14.6 3 14 3H3C2.4 3 2 3.4 2 4V13C2 13.6 2.4 14 3 14H15V4ZM6 16C4.9 16 4 16.9 4 18C4 19.1 4.9 20 6 20C7.1 20 8 19.1 8 18C8 16.9 7.1 16 6 16Z",
          fill: "currentColor"
        })
      ])
    ]),
    /*#__PURE__*/_createTextVNode("Card Number ")
  ])
], -1))
const _hoisted_16 = { class: "fw-bold text-end" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-muted" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 me-2" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          d: "M20 8H16C15.4 8 15 8.4 15 9V16H10V17C10 17.6 10.4 18 11 18H16C16 16.9 16.9 16 18 16C19.1 16 20 16.9 20 18H21C21.6 18 22 17.6 22 17V13L20 8Z",
          fill: "currentColor"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.3",
          d: "M20 18C20 19.1 19.1 20 18 20C16.9 20 16 19.1 16 18C16 16.9 16.9 16 18 16C19.1 16 20 16.9 20 18ZM15 4C15 3.4 14.6 3 14 3H3C2.4 3 2 3.4 2 4V13C2 13.6 2.4 14 3 14H15V4ZM6 16C4.9 16 4 16.9 4 18C4 19.1 4.9 20 6 20C7.1 20 8 19.1 8 18C8 16.9 7.1 16 6 16Z",
          fill: "currentColor"
        })
      ])
    ]),
    /*#__PURE__*/_createTextVNode("Transaction Date ")
  ])
], -1))
const _hoisted_18 = { class: "fw-bold text-end" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "text-muted" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2 me-2" }, [
      /*#__PURE__*/_createElementVNode("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }, [
        /*#__PURE__*/_createElementVNode("path", {
          d: "M20 8H16C15.4 8 15 8.4 15 9V16H10V17C10 17.6 10.4 18 11 18H16C16 16.9 16.9 16 18 16C19.1 16 20 16.9 20 18H21C21.6 18 22 17.6 22 17V13L20 8Z",
          fill: "currentColor"
        }),
        /*#__PURE__*/_createElementVNode("path", {
          opacity: "0.3",
          d: "M20 18C20 19.1 19.1 20 18 20C16.9 20 16 19.1 16 18C16 16.9 16.9 16 18 16C19.1 16 20 16.9 20 18ZM15 4C15 3.4 14.6 3 14 3H3C2.4 3 2 3.4 2 4V13C2 13.6 2.4 14 3 14H15V4ZM6 16C4.9 16 4 16.9 4 18C4 19.1 4.9 20 6 20C7.1 20 8 19.1 8 18C8 16.9 7.1 16 6 16Z",
          fill: "currentColor"
        })
      ])
    ]),
    /*#__PURE__*/_createTextVNode("Customer ")
  ])
], -1))
const _hoisted_20 = { class: "fw-bold text-end" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title fs-5 pe-3" }, [
    /*#__PURE__*/_createTextVNode(" Chargeback Timeline"),
    /*#__PURE__*/_createElementVNode("span", { class: "ms-3 badge badge-light-primary" })
  ])
], -1))
const _hoisted_22 = { class: "card-body pt-6" }
const _hoisted_23 = { class: "timeline-label" }
const _hoisted_24 = { class: "timeline-item" }
const _hoisted_25 = { class: "timeline-label w-auto fw-bold text-gray-800 fs-8 me-3" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline-badge" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-genderless text-gray-600 fs-1" })
], -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold text-gray-700 ps-3 fs-7" }, " Transaction Completed ", -1))
const _hoisted_28 = { class: "timeline-item text-primary" }
const _hoisted_29 = { class: "timeline-label w-auto fw-bold text-gray-800 fs-8 me-3" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline-badge" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-genderless text-gray-600 fs-1" })
], -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold text-gray-700 ps-3 fs-7" }, " Chargeback Created ", -1))
const _hoisted_32 = { class: "timeline-item" }
const _hoisted_33 = { class: "timeline-label w-auto fw-bold text-gray-800 fs-8 me-3" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline-badge" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-genderless text-gray-600 fs-1" })
], -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold text-gray-700 ps-3 fs-7" }, " Response Created ", -1))
const _hoisted_36 = { class: "timeline-item" }
const _hoisted_37 = { class: "timeline-label w-auto fw-bold text-gray-800 fs-8 me-3" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "timeline-badge" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-genderless text-gray-600 fs-1" })
], -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "fw-semibold text-gray-700 ps-3 fs-7" }, "Response Sent", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("table", _hoisted_5, [
          _createElementVNode("tbody", _hoisted_6, [
            _createElementVNode("tr", null, [
              _hoisted_7,
              _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.chargeback.parent_id), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_9,
              _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.chargeback.case_number), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_11,
              _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.chargeback.dispute_date), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_13,
              _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.chargeback.dispute_amount), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_15,
              _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.incomings[0] ? _ctx.incomings[0].card.number : ""), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_17,
              _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.incomings[0]
                    ? _ctx.incomings[0].transaction_date.split(" ")[0]
                    : ""), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_19,
              _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.incomings[0] ? _ctx.incomings[0].card_holder.full_name : ""), 1)
            ])
          ])
        ])
      ]),
      _hoisted_21,
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.incomings[0] ? _ctx.incomings[0].transaction_date.split(" ")[0] : ""), 1),
            _hoisted_26,
            _hoisted_27
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.incomings[0] ? _ctx.incomings[0].dispute_date.split(" ")[0] : ""), 1),
            _hoisted_30,
            _hoisted_31
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.incomings[0]
                  ? _ctx.incomings[0].found_date.split(" ")[0]
                  : "0000-00-00"), 1),
            _hoisted_34,
            _hoisted_35
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.chargeback.sent_date
                  ? _ctx.chargeback.sent_date.split(" ")[0]
                  : "0000-00-00"), 1),
            _hoisted_38,
            _hoisted_39
          ])
        ])
      ])
    ])
  ]))
}